import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import ja from './ja'

import { isDark } from '@/libs/colors'

Vue.use(Vuetify)

Vue.mixin({
  methods: {
    /**
     * 指定された色名の色コードを返す
     *
     * @param {String} colorName テーマの色名
     * @return {String} 色コードを返す
     */
    themeColor (colorName) {
      const color = this.$vuetify.theme.currentTheme[colorName]
      if (!color) {
        throw new Error(`ArgumentError: themeColor(${colorName})`)
      }

      return color
    },

    /**
     * 指定された色の明暗を判定する
     *
     * @param {String} colorName テーマの色名
     * @return {Boolean} 暗い色なら true を返す
     */
    isDarkColor (colorName) {
      return isDark(this.themeColor(colorName))
    }
  }
})

const defaultTheme = {
  options: {
    customProperties: true
  },
  dark: false,
  themes: {
    light: {
      primary: '#1976D2',
      secondary: '#424242',
      accent: '#82B1FF',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FB8C00',
      appbar: '#F5F5F5',
      footer: '#F5F5F5',
      workspace: '#FFFFFF',

      'cal-week': '#7da06c',
      'cal-holiday': '#F44336',
      'cal-saturday': '#3F51B5',

      'cal-campaign': '#03A9F4',
      'cal-high': '#FF9800',

      'cal-empty': '#8bc34a',
      'cal-afew': '#ffc107',
      'cal-occupied': '#e0e0e0',
      'cal-closed': '#d0d0d0'
    },
    dark: {
      primary: '#2196F3',
      secondary: '#424242',
      accent: '#FF4081',
      error: '#FF5252',
      info: '#2196F3',
      success: '#4CAF50',
      warning: '#FB8C00',
      appbar: '#272727',
      footer: '#272727',
      workspace: '#121212',

      'cal-week': '#7da06c',
      'cal-holiday': '#F44336',
      'cal-saturday': '#448AFF',

      'cal-campaign': '#03A9F4',
      'cal-high': '#FF9800',

      'cal-empty': '#8bc34a',
      'cal-afew': '#ffc107',
      'cal-occupied': '#e0e0e0',
      'cal-closed': '#d0d0d0'
    }
  }
}

/**
 * Vuetify インスタンス
 */
const vuetify = new Vuetify({
  lang: {
    locales: { ja },
    current: 'ja'
  },
  icons: {
    iconfont: 'md'
  },
  theme: defaultTheme
})

export default vuetify

/**
 * vuetify にテーマを設定する
 *
 * @param {Object} theme テーマ情報
 */
export function setTheme (theme) {
  // テーマ基調を設定する
  vuetify.framework.theme.dark = !!theme.dark

  // 色を設定するテーマを参照する
  const based = theme.dark ? 'dark' : 'light'
  const vuetheme = vuetify.framework.theme.themes[based]

  // デフォルトのテーマ色を設定する
  const defaults = defaultTheme.themes[based]
  for (const key in defaults) {
    vuetheme[key] = defaults[key]
  }

  // org のテーマ色を設定する
  if (theme.colors) {
    for (const key in theme.colors) {
      vuetheme[key] = theme.colors[key]
    }
  }
}
